import Fetcher from './fetcher';
import getConfig from '../config';
import * as firebase from 'firebase';

/**
 * This class returns prepared axios calls that already contain the proper headers and url for each API call in this app.
 * There probably is a better way to do this, but for now this works.
 */
class Uploader {
  /**
   * Create new instance of Fetcher
   * @param {String} jwtToken Firebase auth token
   */
  constructor(jwtToken) {
    this.fetcher = Fetcher.init(jwtToken);
    this.config = getConfig();
  }

  /**
   * Helper to initialize the Fetcher class
   * @param {String} jwtToken 
   */
  static init(jwtToken) {
    return new Uploader(jwtToken);
  }

  generateRef(){
    return Math.round(Math.random() * 10000000000000).toString(16)
  }
  
  uploadFile = (uploadAction, data, dataset, datasetLocation, processShortName = "amp") => {
    const callFetcher = () => this.callFetcher(uploadAction, data, dataset, datasetLocation, processShortName);
    // If `file` we need to upload to the firebase bucket before communicating with the API
    if (uploadAction === "file") {
      // Take the file reference from the upload data and set it to undefined, so that we won't send it to the API
      let {file} = data;
      data.file = undefined;
      data.fileDest = `${processShortName}/${dataset}/loaded/${this.generateRef()}`; // define the destination in the bucket

      // Initialize the bucket connection and store reference to the to-be-uploaded file
      var storage = firebase.app().storage(this.config.buckets[datasetLocation]);
      let uploadRef = storage.ref().child(data.fileDest);

      return uploadRef.put(file).then(() => {
        return callFetcher();
      });
    } else { // otherwise we can call the fetcher right away
      return callFetcher();
    }
  }
  
  callFetcher = (uploadAction, data, dataset, datasetLocation, processShortName) => {
    if (processShortName === "amp") {
      return this.fetcher.ampUpload(uploadAction, data, dataset);
    }
    return this.fetcher.poiUpload(uploadAction, data, dataset);
  }
}

export default Uploader;



// WEBPACK FOOTER //
// ./src/util/uploader.js